const configuredApiUrl = process.env.REACT_APP_API_URL || '';

const isLocalhostApiUrl = /^https?:\/\/(?:localhost|127\.0\.0\.1|\[::1\])(?::\d+)?(?:\/|$)/i.test(configuredApiUrl);

const apiUrl = process.env.NODE_ENV === 'production' && isLocalhostApiUrl
  ? '/api'
  : configuredApiUrl || '/api';

export default apiUrl;
